import { Database } from "@revelate/types";

export const getTeamInitials = (
  team: Pick<Database["public"]["Tables"]["teams"]["Row"], "name"> | null
) => {
  return team?.name.slice(0, 2).toUpperCase() || "";
};
